import React from 'react'
import styled from 'styled-components'
import { ReactComponent as CheckIcon } from '../../assets/check.svg'

const FilterItemContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  cursor: pointer;
  /*border-bottom: 0.5px solid #d8d8d8;*/
`

const FilterItemCheckBox = styled.div`
  width: 14px;
  height: 14px;
  border: 1px solid ${props => props.theme.accordion.text};
  margin-right: 5px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;

  ${props =>
    props.select === true &&
    `
    border: 1px solid #FF5E6D;
    background-color: #FF5E6D;
  `}
`

const Check = styled(CheckIcon)`
  padding: 0;
  margin: 0;
  width: 10px;
  visibility: ${props => (props.select === 'true' ? 'visible' : 'hidden')};
`

const Label = styled.div`
  color: ${props => props.theme.accordion.text};
`

const SquareCheckBox = ({ label, value, checked, onClick }) => {
  //const [select, setSelected] = useState(false)
  const handleClick = e => {
    e.stopPropagation()
    if (onClick) onClick()
  }

  return (
    <FilterItemContainer onClick={handleClick}>
      <FilterItemCheckBox select={checked}>
        <Check select={checked.toString()} />
      </FilterItemCheckBox>
      {label && <Label>{label}</Label>}
    </FilterItemContainer>
  )
}

export default SquareCheckBox
